<template>
  <div class="rewardList root ">
    <div class v-if="rewardsStatus == 'loading'">
      <div v-for="i in 2" :key="i + '_'" class="row py-1 px-1">
        <div class="col px-1">
          <vue-content-loading class :weight="'100%'" :height="300">
            <rect rx="15" ry="15" width="100%" height="300" />
          </vue-content-loading>
        </div>
        <div class="col px-1">
          <vue-content-loading class :weight="'100%'" :height="300">
            <rect rx="15" ry="15" width="100%" height="300" />
          </vue-content-loading>
        </div>
      </div>
    </div>
    <div v-show="rewardsStatus == 'ok'" class="rewardlist">
      <div
        v-for="it in data"
        :key="it.id"
        class="reward-item"
      >
        <RewardCard
          :reward="it"
          @select="gotoReward"
          @image-load="$store.commit('SET_REWARDS_STATUS', 'ok')"
        />
      </div>
    </div>
    <div v-if="rewardsStatus == 'nodata'" class="text-center my-4">
      Coming soon
    </div>
    <div v-if="rewardsStatus == 'error'" class="text-center my-4">
      Coming soon!
    </div>
  </div>
</template>

<script>
import VueContentLoading from "vue-content-loading";
import RewardCard from "@/components/RewardCard.vue";

export default {
  name: "rewardList",
  components: { VueContentLoading, RewardCard },
  data() {
    return {
      statusData: "loading",
    };
  },
  computed: {
    data() {
      const filtered = this.rewardsData?.filter(rw => rw.categoryId !== 24);
      if (this.activeCatID > 0) {
        return filtered?.filter((item) => {
          return item.categoryId == this.activeCatID;
        });
      } else {
        let arrayList = filtered?.filter(rw => rw.category?.title !== "รางวัลพิเศษ" );
        let specialArrayList = filtered?.filter(rw => rw.category?.title == "รางวัลพิเศษ");

        const reward = arrayList?.sort(
          (a, b) => b.redeemPoint - a.redeemPoint
        );
        const specialReward = specialArrayList?.sort(
          (a, b) => b.redeemPoint - a.redeemPoint
        );

        return specialReward?.concat(reward);
      }
    },
    rewardsData() {
      return this.$store.state.rewards.data;
    },
    activeCatID() {
      return this.$store.state.activeCategoryID;
    },
    rewardsStatus() {
      return this.$store.state.rewardsStatus;
    },
  },
  methods: {
    gotoReward(reward_id) {
      this.$router.push({
        path: "/reward/" + reward_id,
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.rewardList.root {
  padding: 0px 16px 20px 16px !important;
  background: #FFFFFF;
}

.title {
  font-size: 1.2em;
}

.rewardlist {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  padding: 0;
}

.reward-item {
  padding: 4px 0;
  flex: 0 0 calc(50% - 6px);
  max-width: calc(50% - 6px);
}

.rd_expiry_item {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #727983;
}

.rd_point_txt_item {
  font-size: 0.7em;
  margin-top: -7px;
}
</style>
